export class CoordenatesPage {
  constructor(
    public x: number,
    public y: number,
    public page: string,
    public adjustMarginY: number = 0) { }
}
